import { useReactiveVar } from '@apollo/client'
import { Search } from '@mui/icons-material'
import { InputAdornment, TextField } from '@mui/material'
import { queryFilterVar } from 'context'
import { useSegmentInteraction } from 'hooks/analytics/segment'

export const QueryFilter = () => {
  const query = useReactiveVar(queryFilterVar)
  const { track } = useSegmentInteraction()
  return (
    <TextField
      sx={{ width: '100%' }}
      variant="outlined"
      size="small"
      color="secondary"
      placeholder="Search by event name"
      value={query}
      onChange={(e) => {
        const nextQuery = e.target.value
        track('Events "query" filter changed', { filterValue: nextQuery })
        queryFilterVar(nextQuery)
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ ml: 2 }}>
            <Search />
          </InputAdornment>
        )
      }}
    />
  )
}
